// Service Stratégie média (audiences, plan, moteur d'étapes + lancement batch).
import { getRequest, postRequest, patchRequest } from "./api/apiService";

export const fetchAudiences = (category, platform) => getRequest("/api/strategy/audiences", { category, platform });
export const buildPlan = (payload) => postRequest("/api/strategy/plan", payload);
export const fetchCategories = () => getRequest("/api/strategy/categories");

// Moteur d'étapes : sauvegarde du plan, validation, lancement en batch.
export const savePlan = (payload) => postRequest("/api/strategy/plan/save", payload);
export const fetchSteps = (planId) => getRequest("/api/strategy/steps", { planId });
export const validateStep = (id, validated) => patchRequest(`/api/strategy/steps/${id}`, { validated });
export const validateAll = (planId, validated = true) => postRequest("/api/strategy/steps/validate-all", { planId, validated });
export const launchPlan = (planId) => postRequest("/api/strategy/launch", { planId });

// Produits Shopify — pour lancer une stratégie à partir d'un produit (image/nom).
export const fetchShopifyProducts = () => getRequest("/api/ads/shopify-oauth/products");
